<template>
    <div id="app">
        <!--<keep-alive>-->
            <Header/>
        <!--</keep-alive>-->
        <!--<keep-alive>-->
            <div class="main-container">
                <router-view />
            </div>
        <!--</keep-alive>-->
        <!--<keep-alive>-->
            <Bottom/>
        <!--</keep-alive>-->
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Bottom from '@/components/Footer.vue'

    export default {
        name: 'App',
        components: {
            Header,
            Bottom
        },
        data() {
            return {}
        }
    }
</script>

<style>
</style>
